<template>
  <footer class="footer">
    <div class="footer--inner py-m px-xl flex">
      <div class="footer--inner__bottom">
        <router-link class="logo-wrap" to="/">
          <logo />
        </router-link>
        <div class="creds-wrap">
          <span class="creds"
            >MIS IMPLANTS TECHNOLOGIES LTD. 2020. ALL RIGHTS RESERVED</span
          >
          <span v-if="$device !== 'mobile'" class="links">
            <a
              target="_blank"
              href="https://www.mis-implants.com/home/Privacy-Policy"
              >{{localize('privacy_policy')}}</a
            >
            <a
              target="_blank"
              href="https://www.mis-implants.com/home/Privacy-Policy?cookies"
              >Cookies Policy</a
            >
          </span>
        </div>
        <span v-if="$device === 'mobile'" class="links mobile">
          <a
            target="_blank"
            href="https://www.mis-implants.com/home/Privacy-Policy"
            >{{localize('privacy_policy')}}</a
          >
          <a
            target="_blank"
            href="https://www.mis-implants.com/home/Privacy-Policy?cookies"
            >Cookies Policy</a
          >
        </span>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState, mapGetters } from "vuex";

import Logo from "@/components/Logo.vue";
export default {
  components: {
    Logo
  },
  computed: {
    ...mapState(["$device"]),
    ...mapGetters([])
  },
  methods: {}
};
</script>
<style lang="stylus">
.logged-out .footer
.popped-layout + .footer
  position absolute
  bottom 0
.footer
	background gray_0
	width 100%
	&--inner
		&__bottom
      margin 0 auto
      _flex(column,wrap,flex-start,flex-start)
      // +above(815px)
      //   _flex(row,wrap,center, flex-start, true)
      .logo-wrap
        margin-right 8px
        +above(400px)
          max-width 120px
          margin-right 20px
        svg
          fill blue_brand
          max-width 100%
      span
        display block
        text-align left
        font-size 10.5px
        font-weight 300
        +above(400px)
          font-size 13px
        &.creds
          color gray_5
          margin-top 5px
          font-weight 300 !important
        &.links
        &.mobile
          flex 0 0 100%
          font-size 12px
          // margin 15px 0
      a
        color gray_7 !important
        margin 2px 10px 0 0
        opacity 0.8
        display inline-block
        font-weight 300 !important
        hoverize(1, opacity)
</style>
